import React from 'react';
import classes from './style.module.scss';

const Footer = ({ className }) => {
    const year = new Date().getFullYear();

    return (
        <div
            className={
                className !== undefined
                    ? `${className} ${classes.container}`
                    : classes.container
            }
        >
            <p className={classes.rights}>Все права защищены © {year}</p>
        </div>
    );
};
export default Footer;
//by Hokitoru <3
